import { Box, Button } from '@mui/material'
import React, { createRef, useState } from 'react'
import { IState } from '../../../../redux/reducers/rootReducers';
import { connect } from 'react-redux';
import CustomSelect from '../../../common/customSelect/CustomSelect';
import CustomFormLabel from '../../../common/form-label/CustomFormLabel ';
import { bulkUpdateNewTickets, getBulkNewTicket } from '../../../../redux/actions/TicketsManagement/TicketsManagement';
import { triggerAppAlert } from '../../../../redux/actions/SelfServicePortal/ContactAid/ContactAid';
import { debounce } from 'lodash';
import { useNavigate } from 'react-router-dom';
import TicketTypeDropdown from './TicketTypeDropdown';
import { TextBoxLatest } from '../../../common/TextBoxLatest/TextBoxLatest';



interface IAgentGroupOptionProps{
    groups : any[];
    dispatch:any;
    ticketStatus : any [];
    selectedTicketIds:any;
    handleClose:any;
    statusToUpdate?:string;
}
function AgentGroupOption(props:IAgentGroupOptionProps) {
     const noteRef: any = createRef();
    const {groups=[], ticketStatus=[],dispatch,selectedTicketIds,handleClose,statusToUpdate=""} = props;
    const [agentOptions,setAgentOptions] = useState<any>([])
    const navigate = useNavigate();
    const [values,setValues] = useState<any>({
        fieldVal:  {
            groupId : null,
            agentId : null,
        },
        errors:{
            groupId : null,
            agentId : null,
        }
    })
    const loadTickets = debounce((statusIds:number[]=[],groupIds:number[]=[]) =>{
        dispatch(getBulkNewTicket("",statusIds,groupIds,10000,handleClose))
    },150);
    const getAllTicket = () =>{
        console.log("AllNewTickets", groups,ticketStatus);
        const statusIds:number[] = [];
        const groupIds:number[] = [];
        ticketStatus.map((i:any)=>{if(i.name === "New"){statusIds.push(i.id);}})
        groups.map((i:any)=>{groupIds.push(i.id);})
        loadTickets(statusIds,groupIds);
    }
    
    const validateForm = () =>{
         if(!values?.fieldVal?.ticketType?.id && !values?.fieldVal?.groupId?.id && !values?.fieldVal?.status?.id && noteRef?.current?.value.trim() === ""){
            dispatch(triggerAppAlert(`Please fill the fields to be updated`, 'warning'));
            return false;
        }

        let valid = true;
        let tempObj:any = {};
        // if(!values?.fieldVal?.groupId?.id){
        //     valid =  false;
        //     tempObj.groupId = "Group is required";
        // }
        if(values?.fieldVal?.groupId?.id && !values?.fieldVal?.agentId?.id){
            valid =  false;
            tempObj.agentId = "Agent is required";
        }

        if(values?.fieldVal?.ticketType?.id && !values?.fieldVal?.priority?.id){
            valid =  false;
            tempObj.priority = "Priority is required";
        }

        if(values?.fieldVal?.ticketType?.id && !values?.fieldVal?.category?.id){
            valid =  false;
            tempObj.category = "Category is required";
        }

        if(values?.fieldVal?.ticketType?.id && !values?.fieldVal?.category?.id){
            valid =  false;
            tempObj.category = "Category is required";
        }

        if(fieldsNeedNote.includes(values?.fieldVal?.status?.name || "") && noteRef?.current?.value.trim() === ""){
            valid =  false;
            tempObj.category = "Note is required";
        }
       

        if(!valid){
            dispatch(triggerAppAlert(`Please fill all the required fields`, 'warning'));
            setValues({
                ...values,
                errors:{
                    ...values.errors,
                    ...tempObj
                }
            })
        }
        return valid
    }
    const proceedDeleteItems = () =>{
       
        const isValid = validateForm();
        if(!isValid) return;

        
        const {groupId, agentId, status, ticketType, priority, category} = values.fieldVal;
        const payload = {
            "sourceCode": "System",
            "actionType": "BulkUpdate",
            "ticketLogs": {
                "sourceCode": "System",
                "groupId": groupId?.id || 0,
                "agentId": agentId?.id || 0,
                "statusId": status?.id || 0,
                "ticketTypeId": ticketType?.id || 0,
                "priorityId": priority?.id || 0,
                "categoryId": category?.id || 0,
                "note": noteRef?.current?.value || ""
            }
        }
        dispatch(bulkUpdateNewTickets(selectedTicketIds,payload,bulkUpdateNewTicketsCB))
    }
    const bulkUpdateNewTicketsCB = () =>{
        getAllTicket();
        handleClose();
        navigate('/TicketManagementSys');
    }
    const tickTypeHandler = (data:any) =>{
        console.log("tickTypeHandler data", data);
        setValues((old:any)=> ({
            ...old,
            fieldVal:  {
                ...old.fieldVal, 
                ...data
            },
            errors:{
                ...values.errors,
                priority: values.errors.priority ? data.priority ? values.errors.priority :  null : null,
                category: values.errors.category ? data.category ? values.errors.category :  null : null,
            }
        }))
    }
    const [fieldsNeedNote] = useState<string[]>(['Closed','Resolved',"OnHold",'Pending']);
    return (
        <Box>
            <CustomFormLabel
                labelName={"Select Status"}
                isMandotary={false}
                classNames='sml-txt'
            />
            <CustomSelect
                isOpen={false}
                placeholder="Select Status"
                width={"100%"}
                name="statusId"
                isColor={false}
                isDisabled={false}
                isError={values?.errors?.status ? true : false}
                helperText={values?.errors?.status || ""}
                defaultValue={values?.fieldVal?.status || null}
                options={ticketStatus || []}
                handleChange={(e: any) => {
                    setValues({
                        fieldVal:  {
                            ...values.fieldVal,
                            status : e
                        },
                        errors:{
                            ...values.errors,
                            status : null,
                        }
                    })
                }}
                isMulti={false}
                customClassNames="sml-txt-dropdown new-service"
            />
            
            <CustomFormLabel
                labelName={"Select Group"}
                isMandotary={false}
                classNames='sml-txt'
            />
            <CustomSelect
                isOpen={false}
                placeholder="Select Group"
                width={"100%"}
                name="groupId"
                isColor={false}
                isDisabled={false}
                isError={values?.errors?.groupId ? true : false}
                helperText={values?.errors?.groupId || ""}
                defaultValue={values?.fieldVal?.groupId || null}
                options={groups || []}
                handleChange={(e: any) => {
                    setAgentOptions(e?.agentsList || [])
                    setValues({
                        fieldVal:  {
                            ...values.fieldVal,
                            groupId : e,
                            agentId : null,
                        },
                        errors:{
                            ...values.errors,
                            groupId : null,
                            agentId : null
                        }
                    })
                }}
                isMulti={false}
                customClassNames="sml-txt-dropdown new-service"
            />
            {values?.fieldVal?.groupId &&
                <>
                    <CustomFormLabel
                        labelName={"Select Agent"}
                        isMandotary={true}
                        classNames='sml-txt'
                    />
                    <CustomSelect
                        isOpen={false}
                        placeholder="Select Agent"
                        width={"100%"}
                        name="agentId"
                        isColor={false}
                        isDisabled={false}
                        isError={values?.errors?.agentId ? true : false}
                        helperText={values?.errors?.agentId || ""}
                        defaultValue={values?.fieldVal?.agentId || null}
                        options={agentOptions || []}
                        handleChange={(e: any) => {
                            setValues({
                                fieldVal:  {
                                    ...values.fieldVal,
                                    agentId : e,
                                },
                                errors:{
                                    ...values.errors,
                                    agentId : null,
                                }
                            })
                        }}
                        isMulti={false}
                        customClassNames="sml-txt-dropdown new-service"
                    />
                </>
            }


            <TicketTypeDropdown errors={values?.errors} callback={tickTypeHandler} />


            <TextBoxLatest
                title="Note"
                isMandotary={fieldsNeedNote.includes(values?.fieldVal?.status?.name || "")}
                placeholder="Enter the Note"
                ref={noteRef}
                // errorMsg={generateErrorList(error.isValid, error.errors, "note")}
                // isError={generateErrorList(error.isValid, error.errors, "note") ? true : false}
                // onchangeHandler={unsetNoteFieldErrorMsg}
                name="note"
                multiline={true}
            />

            <Box className="pt-1 text-center">
                <Button onClick={handleClose}  variant="outlined" size="small">Cancel</Button> &nbsp;
                <Button onClick={proceedDeleteItems} variant="contained" size="small">Submit</Button>
            </Box>
        </Box>
    )
}


const mapStateToProps = (state:IState) => {
    return ({
        groups : state?.TicketsReducer?.allResponses?.groups,
        ticketStatus : state?.TicketsReducer?.allResponses?.ticketStatus,
    })
  };
  
export default connect(mapStateToProps)(AgentGroupOption);